<template>
  <el-dialog
    title="半自动二次认领"
    :visible.sync="dialogVisible"
    v-if="dialogVisible"
    width="80%"
    class="secondClaimDialog"
    id="secondClaimDialog"
    @close="closeDialog"
  >
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethodHandler="changeMethodHandler"
    >
    </SiruiSearch>
    <!-- 编辑表格 -->
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRule"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      style="margin-top: 30px"
    >
    </vxe-grid>
    <IPagination
      :total="tableTotal"
      :multipleSelection="selectionList"
      @changePageHandler="changePageHandler"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="saveHandler">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import saleInvoiceApi from '@/api/financeCenter/saleInvoice.js';
  import receivablesManageAPI from '@/api/capitalCenter/receivablesManage';
  export default {
    props: {
      businessType: {
        type: String,
        default: '',
      },
      formData: {
        type: Object,
        default: () => {},
      },
      departmentList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        dialogVisible: false,
        rowData: null,
        query: {
          contractBusinessDepartmentName: '',
          // customerName: '',
          receivableSettlementNo: '',
          registerId: '',
        },
        tableData: [],
        tableTotal: 0,
        tableRule: {
          originReceiveMoneyAmount: [
            {
              required: true,
              message: '必填项',
              trigger: ['blur', 'change'],
            },
          ],
        },
        selectionList: [],
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            name: '部门',
            prop: 'contractBusinessDepartmentName',
            type: 'input',
            disabled: true,
          },
          // {
          //   name: '客户',
          //   prop: 'customerName',
          //   type: 'input',
          //   disabled: true,
          // },
          {
            prop: 'receivableSettlementNo',
            name: '结算单号',
            type: 'searchTableSpec',
            searchType: 'receivableSettlement',
            isMultiple: true,
            extraData: {
              settlementStatus: '04',
              companyCode: this.userInfo.companyCode,
              departmentCode: this.userInfo.departmentCode,
              // customerNo: this.query?.customerNo,
            },
            changeMethod: 'changeMethodHandler',
          },
        ];
      },
      tableColumnsList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          { field: 'receivableSettlementNo', title: '结算单号' },
          { field: 'expenseTypeName', title: '费用类型' },
          { field: 'contractNo', title: '合同编号' },
          { field: 'settlementDepartmentName', title: '部门' },
          { field: 'domesticAmount', title: '本币结算金额(含税)' },
          { field: 'collectedAmount', title: '已认领总金额' },
          {
            field: 'sub',
            title: '未认领总金额',
          },
          {
            field: 'originReceiveMoneyAmount',
            title: '本次认领金额',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
            slots: {
              default: ({ row }) => {
                return [<span>{row.originReceiveMoneyAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.originReceiveMoneyAmount}
                    max={999999999.99}
                    min={0}
                    precision={2}
                    onInput={(val) => this.chooseTable(val, row, 'originReceiveMoneyAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'remark',
            title: '备注',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
          },
        ];
      },
    },
    methods: {
      chooseTable(val, row, fieldKey) {
        console.log(val, row, fieldKey, '???');
        row[fieldKey] = val;
        let xTable = this.$refs.xTableRef;
        xTable.updateData();
      },
      // 关闭
      closeDialog() {
        this.dialogVisible = false;
      },
      async openDialog(rowData) {
        console.log(rowData, '--11-->>');
        this.rowData = rowData;
        this.query = {
          ...this.query,
          ...rowData,
          contractBusinessDepartmentName: rowData.claimDepartmentName,
          contractBusinessDepartmentNo: rowData.claimDepartmentNo,
        };
        this.tableData = [];
        this.selectionList = [];
        this.tableTotal = 0;
        this.dialogVisible = true;
      },
      async initTableData() {
        if (!this.query.receivableSettlementNo) {
          this.tableData = [];
          return;
        }
        const {
          data: { code, data },
        } = await this.$axios.post(saleInvoiceApi.RECIVE_SETTLEMENT_LINE_PAGE, {
          contractBusinessDepartmentName: this.query.contractBusinessDepartmentName,
          contractBusinessDepartmentNo: this.query?.contractBusinessDepartmentNo,
          // customerName: this.query.customerName,
          // customerNo: this.query?.customerNo,
          receivableSettlementNo: this.query.receivableSettlementNo,
          settlementLineId: this.query.settlementLineId,
        });
        if (Object.is(code, 0)) {
          const { records, total } = data;
          this.tableData = records.map((item) => {
            return {
              ...item,
              sub: (
                (item['domesticAmount'] ? item['domesticAmount'] : 0) -
                (item['collectedAmount'] ? item['collectedAmount'] : 0)
              ).toFixed(6),
              originReceiveMoneyAmount: (
                (item['domesticAmount'] ? item['domesticAmount'] : 0) -
                (item['collectedAmount'] ? item['collectedAmount'] : 0)
              ).toFixed(6),
            };
          });
          this.tableTotal = total;
        } else {
          console.error('获取数据失败');
        }
      },
      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
      },
      // 判断当前勾选的本次认领金额是否小于外面行的金额
      async saveHandler() {
        if (this.selectionList.length == 0) {
          this.$message.error('请选择行');
          return;
        }
        // localReceiveMoneyAmount
        // 1.判断全部选中->本次认领金额 和要小于localReceiveMoneyAmount
        const selectionListAmount = this.selectionList.reduce(
          (pre, cur) => (pre + +cur.originReceiveMoneyAmount ? cur.originReceiveMoneyAmount : 0),
          0
        );
        console.log(
          selectionListAmount,
          this.rowData.secondTotalAmount.localReceiveMoneyAmount,
          '提交'
        );
        // if (selectionListAmount > this.rowData.secondTotalAmount.localReceiveMoneyAmount) {
        //   this.$message.error('本次认领金额大于收款金额');
        //   return;
        // }
        const isValid = this.selectionList.every((item) => Boolean(item.originReceiveMoneyAmount));
        if (!isValid) {
          this.$message.error('请补充本次未认领金额');
          return;
        }
        const isValid2 = this.selectionList.every((item) => {
          console.log(
            item['originReceiveMoneyAmount'],
            item['domesticAmount']
              ? item['domesticAmount']
              : 0 - item['collectedAmount']
              ? item['collectedAmount']
              : 0
          );
          return (
            item['originReceiveMoneyAmount'] >
            (item['domesticAmount']
              ? item['domesticAmount']
              : 0 - item['collectedAmount']
              ? item['collectedAmount']
              : 0)
          );
        });
        console.log(isValid2);
        if (isValid2) {
          this.$message.error('本次认领金额不能大于未认领金额');
          return;
        }
        // 2.将选中的数据发送出去反填到二次认领中
        const fundCollectionSecondClaimList = this.selectionList.map((item) => {
          return {
            // ...item,
            settlementLineId: item.id, // 结算行id
            customerNo: this.rowData.customerNo,
            customerName: this.rowData.customerName, // 客户
            receivedType: item.expenseType, // 收款类别
            claimDepartmentNo: this.rowData.claimDepartmentNo, // 部门
            claimDepartmentName: this.rowData.claimDepartmentName, // 部门描述
            projectCode: this.rowData.projectCode, //   //项目
            settlementNo: this.query.receivableSettlementNo, //  结算单
            salesOrderNo: item.contractNo,
            contractNo: item.contractNo, // 业务订单
            originProformaInvoiceAmount: '', // 形式发票金额
            localProformaInvoiceAmount: '', // 形式发票金额（本币）
            originReceiveMoneyAmount: +item.originReceiveMoneyAmount, // 收款金额
            localReceiveMoneyAmount: +item.originReceiveMoneyAmount, // 收款金额（本币）
            firstClaimId: this.rowData.id,
            ladingNo: this.rowData.ladingNo,
            purchaseOrderNo: this.rowData.purchaseOrderNo,
            originDomesticBankDeductFee: this.rowData.originDomesticBankDeductFee,
            localDomesticBankDeductFee: this.rowData.localDomesticBankDeductFee,
            originForeignBankDeductFee: this.rowData.originForeignBankDeductFee,
            localForeignBankDeductFee: this.rowData.localForeignBankDeductFee,
            remark: item.remark, //备注
          };
        });
        const postData = {
          id: this.formData.id,
          departmentNos: this.departmentList.map((item) => item.value),
          businessType: this.businessType,
          fundCollectionSecondClaimList,
          delFundCollectionSecondClaimList: [],
        };
        const {
          data: { code, msg },
        } = await this.$axios.post(receivablesManageAPI.SAVE_COLLECTIONCLAIM_SECOND, postData);
        if (code === 0) {
          this.$message.success('操作成功');
        } else {
          this.$message.error(msg);
        }
        this.closeDialog();
      },
      resetBtnClick() {
        this.query.receivableSettlementNo = '';
        this.tableData = [];
        this.tableTotal = 0;
      },
      async searchBtnClick() {
        if (!this.query.receivableSettlementNo) {
          this.$message.warning('请选择结算单号');
          return;
        }
        await this.initTableData();
      },
      changeMethodHandler({ val, prop }) {
        const rowData = val && val[0];
        console.log(rowData, prop);
        if (prop == 'receivableSettlementNo') {
          this.query.receivableSettlementNo = rowData.receivableSettlementNo;
          this.initTableData();
        }
      },
      // 选择
      handleSelectionChange(row) {
        console.log(row);
        this.selectionList = row.selection;
      },
    },
  };
</script>

<style></style>
